import { Component, OnInit } from '@angular/core';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { DatagridService, PagedResultGeneric } from 'src/app/shared';
import { ProfileAdvancedSearchParams } from 'src/app/profiles/search/profile-advanced-search-params.model';
import { ProfileSearchService, ProfileSearchResult } from 'src/app/profiles/search';
import { ProfileAdvancedSearchResultDto } from 'src/app/profiles/search/dto/profile-advanced-search-result.dto';

@Component({
  selector: 'wl-committee-member-profile-grid',
  templateUrl: './committee-member-profile-grid.component.html',
  styleUrls: ['./committee-member-profile-grid.component.less'],
  providers: [ProfileSearchService],
    standalone: false
})
export class CommitteeMemberProfileGridComponent
  extends LazySelectableTableComponent<ProfileAdvancedSearchParams, ProfileAdvancedSearchResultDto>
  implements OnInit {
  constructor(datagridService: DatagridService, private _profileSearchService: ProfileSearchService) {
    super('ProfileId', datagridService);
  }

  ngOnInit(): void {}

  public getSelectedIds(): Promise<number[]> {
    return this.fetchAllSelectedIds<number>();
  }

  fetchResults(): Promise<PagedResultGeneric<ProfileAdvancedSearchResultDto>> {
    return this._profileSearchService.advancedSearch(this.searchParams);
  }

  clearSearch() {
    this.searchParams = new ProfileAdvancedSearchParams();
    this.searchResult = null;
  }
}
